import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { PortalMode } from '../stores/portal.store';

interface PortalContainerProps {
    mode: PortalMode;
    className?: string;
    children?: ReactNode;
}

export const PortalContainer: FC<PortalContainerProps> = ({ children, className, mode }) => {
    return (
        <div
            className={classNames('portal', className, {
                'portal-mobile': mode.mobile,
                'portal-tablet': mode.tablet,
                'portal-desktop': mode.desktop,
                'portal-desktop-narrow': mode.desktopNarrow,
                'portal-desktop-wide': mode.desktopWide,
            })}
        >
            {children}
        </div>
    );
};
